
const modifyPayload = {
    CUENTA_CARGO_CANAL:'CIC',
    CUENTA_CARGO_CODE_RELACION:'009',
    CUENTA_CARGO_FETCH_DATE:'21-06-2017',
    CUENTA_CARGO_NUMERO_SECUENCIA:'001',
    CUENTA_CARGO_TABLE_CUENTO:'R',
}

module.exports = modifyPayload;
